import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTrash = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.625 5.25H19.25v-.875a2.625 2.625 0 0 0-2.625-2.625h-5.25A2.625 2.625 0 0 0 8.75 4.375v.875H4.375a.875.875 0 0 0 0 1.75h.875v15.75A1.75 1.75 0 0 0 7 24.5h14a1.75 1.75 0 0 0 1.75-1.75V7h.875a.875.875 0 1 0 0-1.75ZM10.5 4.375a.875.875 0 0 1 .875-.875h5.25a.875.875 0 0 1 .875.875v.875h-7v-.875ZM21 22.75H7V7h14v15.75Zm-8.75-11.375v7a.875.875 0 1 1-1.75 0v-7a.875.875 0 1 1 1.75 0Zm5.25 0v7a.875.875 0 1 1-1.75 0v-7a.875.875 0 1 1 1.75 0Z" />
  </svg>
);
export default SvgTrash;
